import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, umsUrl } from '../../../../../Containers/Config/index.js';
import { CHANGE_CHAUFFEUR_PASSWORD, CHANGE_CHAUFFEUR_PASSWORD_SUCCESS, CHANGE_CHAUFFEUR_PASSWORD_ERROR } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* changeChauffeurPassword({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/airport-transfers/chauffeur/password-reset/confirm`,
      method: 'POST',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CHANGE_CHAUFFEUR_PASSWORD_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CHANGE_CHAUFFEUR_PASSWORD_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CHANGE_CHAUFFEUR_PASSWORD_ERROR, payload: error });
  }
}

export function* watchchangeChauffeurPassword() {
  yield takeEvery(CHANGE_CHAUFFEUR_PASSWORD, changeChauffeurPassword);
}

function* changeChauffeurPasswordSaga() {
  yield all([fork(watchchangeChauffeurPassword)]);
}

export default changeChauffeurPasswordSaga;
